import { Gesture, gestureLayers } from "./BaseGesture"

export default function () {
  const { getCollectionViewFileFromEvent, getPropertyIdFromEvent, state: gestureState, clickedCloseEnough } = useGestures()
  const { isSelected } = useSelection()
  const { isAuthorizedToEditProperty } = useAuthorization()
  const { emitEntityEvent } = useEvents()
  class CollectionViewFileClickPropertyToEdit extends Gesture {
    override layer = gestureLayers.mainViewProperty

    didSelect = false

    override reset() {
      this.didSelect = false
    }

    override async onMouseDown(mouse: MouseEvent) {
      const file = getCollectionViewFileFromEvent(mouse)
      if (!file)
        return
      if (!isSelected(file.id))
        return
      const propertyId = getPropertyIdFromEvent(mouse)
      if (!propertyId)
        return

      // don't capture as this could be for a different event

      this.didSelect = true
    }

    override async onMouseUp(
      mouse: MouseEvent,
    ) {
      if (!this.didSelect)
        return this.reset()
      const file = getCollectionViewFileFromEvent(mouse)
      if (!file)
        return this.reset()
      if (!isSelected(file.id))
        return this.reset()
      const propertyId = getPropertyIdFromEvent(mouse)
      if (!propertyId)
        return this.reset()

      // if the position of the mouse is where it was on mouse down, then we're a click
      if (!gestureState.value.mouseDown || !clickedCloseEnough(gestureState.value.mouseDown, mouse))
        return this.reset()

      this.capture()

      if (!isAuthorizedToEditProperty(file)) {
        console.warn("Not authenticated, ignoring property edit request")
        return this.reset()
      }

      this.debug("Started editing File property", file, file.property(propertyId))

      emitEntityEvent("requestedPropertyEdit", file.id, {
        fileId: file.id,
        propertyId,
        location: "collection-view",
      }, false)

      return this.reset()
    }
  }
  return new CollectionViewFileClickPropertyToEdit()
}
